// M6 — AI Üretim Akışı (plan §4.5 + §7).
// Confirm modal + progress + done + status endpoint'leri için schema'lar.

import { z } from "zod";

export const ProjectGenerateEstimateResponseSchema = z.object({
  sectionCount: z.number().int().nonnegative(),
  estimatedDurationMs: z.number().int().nonnegative(),
  estimatedCostUsd: z.number().nonnegative(),
  activeProvider: z.enum(["openai", "anthropic", "dummy"]),
  activeModel: z.string().min(1),
  canGenerate: z.boolean(),
  blockerReason: z.string().nullable(), // "missing_required" | "active_generation" | null
});
export type ProjectGenerateEstimateResponse = z.infer<typeof ProjectGenerateEstimateResponseSchema>;

export const ProjectGenerateStartResponseSchema = z.object({
  version: z.number().int().positive(),
  sectionCodes: z.array(z.string()),
  generatedSectionIds: z.array(z.string()),
});
export type ProjectGenerateStartResponse = z.infer<typeof ProjectGenerateStartResponseSchema>;

export const GenerationStatusSchema = z.enum(["queued", "running", "success", "failed"]);
export type GenerationStatus = z.infer<typeof GenerationStatusSchema>;

export const ReviewStatusSchema = z.enum(["pending_review", "approved", "rejected"]);
export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;

export const FailureReasonSchema = z.enum([
  "auth",
  "rate_limit",
  "malformed",
  "content_filter",
  "network",
  "timeout_stale",
  // Provider error code'ları worker'dan ham geçer — şema gerçek DB değerleriyle hizalı olmalı
  "timeout",
  "unknown",
  // Kanıt belgesi payload'u sağlayıcı tarafından reddedildi (400 + attachment'lı istek)
  "attachment",
]);
export type FailureReason = z.infer<typeof FailureReasonSchema>;

// M11 — kullanılan kanıt belge metadata (audit + UI için).
// LLMAttachment runtime payload'unun audit yansıması (bytes/estimatedTokens hariç).
export const AttachmentUsedSchema = z.object({
  attachmentId: z.string().uuid(),
  filename: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int().nonnegative(),
  questionCode: z.string(),
});
export type AttachmentUsed = z.infer<typeof AttachmentUsedSchema>;

export const GeneratedSectionRowSchema = z.object({
  id: z.string().uuid(),
  sectionCode: z.string(),
  version: z.number().int().positive(),
  generationStatus: GenerationStatusSchema,
  reviewStatus: ReviewStatusSchema,
  failureReason: FailureReasonSchema.nullable(),
  failureMessage: z.string().nullable(),
  retryCount: z.number().int().nonnegative(),
  tokensTotal: z.number().int().nonnegative().nullable(),
  costUsd: z.string().nullable(),
  modelUsed: z.string().nullable(),
  providerUsed: z.string().nullable(),
  generatedAt: z.string().nullable(),
  updatedAt: z.string(),
  // M11 — bu section'da LLM'e gönderilen kanıt belgeler
  attachmentsUsed: z.array(AttachmentUsedSchema).default([]),
});
export type GeneratedSectionRow = z.infer<typeof GeneratedSectionRowSchema>;

export const ProjectGenerateStatusResponseSchema = z.object({
  projectId: z.string().uuid(),
  version: z.number().int().nonnegative(),
  sections: z.array(GeneratedSectionRowSchema),
  summary: z.object({
    total: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    running: z.number().int().nonnegative(),
    queued: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
  }),
  active: z.boolean(),
});
export type ProjectGenerateStatusResponse = z.infer<typeof ProjectGenerateStatusResponseSchema>;

export const ProjectGenerateActiveResponseSchema = z.object({
  active: z.boolean(),
  version: z.number().int().nonnegative(),
});
export type ProjectGenerateActiveResponse = z.infer<typeof ProjectGenerateActiveResponseSchema>;
